import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';
import 'firebase/auth';

firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET
});

export const firebaseDB = firebase.firestore();
export const firebaseFunctions =
  process.env.VUE_APP_FIREBASE_REGION === 'HK'
    ? firebase.app().functions('asia-east2')
    : firebase.functions();
export const firebaseApp = firebase;
export const firebaseStorage = firebase.storage();
